import React from 'react';

import MapProvider from '../context/map';
import MarkersProvider from '../context/markers';
import ActiveAutosProvider from '../context/activeAutos';
import { MapSettingsProvider } from '../context';

import { Props } from '../index';

const withContext = (
  Component: (componentProps: Props) => JSX.Element
) => ({ ...props }: Props) => (
  <MapProvider>
    <MarkersProvider>
      <ActiveAutosProvider>
        <MapSettingsProvider>
          <Component {...props} />
        </MapSettingsProvider>
      </ActiveAutosProvider>
    </MarkersProvider>
  </MapProvider>
);

export default withContext;
